import React from 'react';

import { SurveyMarshal } from '@atlaskit/contextual-survey/SurveyMarshal';

import {
	markAsSeenAndFatigued,
	type SeenMessageConfig,
	sendUserResponse,
} from '../../services/engage-targeting';
import { getFlag, type GetFlagResponse, setFlag } from '../../services/have-i-seen-it';
import ContextualSurvey from '../contextual-survey/main';

interface Props {
	question: string;
	statement: string;
	textPlaceholder?: string;
	fireClickEvent: (event: string) => void;
	aaid: string;
	cloudId: string;
	stargateUrl: string;
	messageId: string;
	variationId: string;
	componentId: number;
	product: string;
	orgId: string;
	workspaceId: string;
	markAsSeenAndFatigued?: (seenMessageConfig: SeenMessageConfig) => Promise<void>;
	sendUserResponse?: (
		cloudId: string,
		stargateUrl: string,
		messageId: string,
		payload: any,
	) => Promise<void>;
	getFlag?: (
		stargateUrl: string,
		cloudId: string,
		flagKey: string,
		aaid: string,
	) => Promise<GetFlagResponse>;
	setFlag?: (
		stargateUrl: string,
		cloudId: string,
		flagKey: string,
		userKey: string,
	) => Promise<void>;
}

export default function ContextualSurveyWithTransition(props: Props): React.JSX.Element {
	return (
		<SurveyMarshal shouldShow={true}>
			{() => (
				<ContextualSurvey
					markAsSeenAndFatigued={markAsSeenAndFatigued}
					sendUserResponse={sendUserResponse}
					getFlag={getFlag}
					setFlag={setFlag}
					{...props}
				/>
			)}
		</SurveyMarshal>
	);
}
